
import { IFieldForm } from "pages/read-documents/model/IFieldForm";

export const fieldsFormContracts = (): IFieldForm[]  => {
    return [
        {
            id: 'itemFormContract',
            name: 'contractNumber',
            type: 'text',
            label: 'Número de contrato',
            placeholder: 'Número de contrato',
            testId: 'itemFormContract',
            isEnable: true
        },
        {
            id: 'contractDateService',
            name: 'contractDateService',
            type: 'datePicker',
            label: 'Fecha de contrato',
            placeholder: '',
            testId: 'contractDateService',
            isEnable: true
        },
        {
            id: 'itemformNit',
            name: 'nitEntidad',
            type: 'text',
            label: 'Nit',
            placeholder: 'Ingrese nit',
            testId: 'itemformNit',
            isEnable: true
        },
        {
            id: 'statusContract',
            name: 'statusContract',
            type: 'Select',
            label: 'Estado contrato',
            placeholder: 'Estado contrato',
            testId: 'statusContract',
            isEnable: true,
            options: [
                { id: 'true', name: 'Vigente' },
                { id: 'false', name: 'Terminado' }
            ]
        },
    ]
}